import { ContentItem } from "../ContentItem/ContentItem";
import { ContentParent } from "../ContentParent";
import { Translate } from "components/common/Translate/Translate";
import { getCDNIcon } from "../ImageResizerContent/ImageResizerContent";
import { translateFunc } from "client/utils/translateFunc";
import { EasyToUseIcon } from "components/common/Icons/EasyToUseIcon";
import { PerfectQualityIcon } from "components/common/Icons/PerfectQualityIcon";
import { ImageFormatsIcon } from "components/common/Icons/ImageFormatsIcon";
import { PrivacyGuaranteedIcon } from "components/common/Icons/PrivacyGuaranteedIcon";
import { LightningFastIcon } from "components/common/Icons/LightningFastIcon";
import { HeartIcon } from "components/common/Icons/HeartIcon";
import { Crop } from "lucide-react";
import { DeviceIcon } from "@/components/common/Icons/DeviceIcon";

export const CropperJpgContent = () => {
    return (
        <ContentParent>
            <ContentItem
                title={<Translate keyName="content-easy-title" />}
                description={<Translate keyName="content-easy-sub-title" />}
                icon={<EasyToUseIcon />}
            />
            <ContentItem
                title={<Translate keyName="content-size-title" />}
                description={<Translate keyName="content-size-sub-title" />}
                icon={<PerfectQualityIcon />}
            />
            <ContentItem
                title={<Translate keyName="content-ratio-title" />}
                description={<Translate keyName="content-ratio-sub-title" />}
                icon={<ImageFormatsIcon />}
            />
            <ContentItem
                title={<Translate keyName="content-privacy-title" />}
                description={<Translate keyName="content-privacy-sub-title" />}
                icon={<PrivacyGuaranteedIcon />}
            />
            <ContentItem
                title={<Translate keyName="content-free-title" />}
                description={<Translate keyName="content-free-sub-title" />}
                icon={<Crop />}
            />
            <ContentItem
                title={<Translate keyName="content-device-title" />}
                description={<Translate keyName="content-device-sub-title" />}
                icon={<DeviceIcon />}
            />
        </ContentParent>
    );
};
